<template>
  <div class="page-report" v-if="detail && detail.journeys">
    <div class="block-flex">
      <div
        class="flex-nav static1" @click="handleChangeJounery(detail.journeys[0])"
        :class="
          detail.journeys[0].journeyName === detail.curJourney[0].journeyName
            ? 'cur'
            : ''
        "
      >
        <img
          :src="
            detail.journeys[0].journeyName === detail.curJourney[0].journeyName
              ? require('@/assets/images/journey/staticed1.png')
              : require('@/assets/images/journey/static1.png')
          "
          class="bg-img"
        />
        <div class="txt1">{{ detail.journeys[0].journeyName }}</div>
      </div>
      <div
        class="flex-nav static2" @click="handleChangeJounery(detail.journeys[1])"
        :class="
          detail.journeys[1].journeyName === detail.curJourney[0].journeyName
            ? 'cur'
            : ''
        "
      >
        <img
          :src="
            detail.journeys[1].journeyName === detail.curJourney[0].journeyName
              ? require('@/assets/images/journey/staticed2.png')
              : require('@/assets/images/journey/static2.png')
          "
          class="bg-img"
        />
        <div class="txt1">{{ detail.journeys[1].journeyName }}</div>
      </div>
      <div
        class="flex-nav static3" @click="handleChangeJounery(detail.journeys[2])"
        :class="
          detail.journeys[2].journeyName === detail.curJourney[0].journeyName
            ? 'cur'
            : ''
        "
      >
        <img
          :src="
            detail.journeys[2].journeyName === detail.curJourney[0].journeyName
              ? require('@/assets/images/journey/staticed3.png')
              : require('@/assets/images/journey/static3.png')
          "
          class="bg-img"
        />
        <div class="txt1">{{ detail.journeys[2].journeyName }}</div>
      </div>
      <div
        class="flex-nav static4" @click="handleChangeJounery(detail.journeys[3])"
        :class="
          detail.journeys[3].journeyName === detail.curJourney[0].journeyName
            ? 'cur'
            : ''
        "
      >
        <img
          :src="
            detail.journeys[3].journeyName === detail.curJourney[0].journeyName
              ? require('@/assets/images/journey/staticed4.png')
              : require('@/assets/images/journey/static4.png')
          "
          class="bg-img"
        />
        <div class="txt1">{{ detail.journeys[3].journeyName }}</div>
      </div>
    </div>
    <div class="block-info block-level">
      <van-collapse v-model="activeNames">
        <van-collapse-item
          class="level-item"
          v-for="(item, index) in detail.curJourney[0].journeyStages"
          :key="index"
          :name="index"
        >
          <template #title>
            <div class="col-title">
              <div class="state-name">{{ item && item.stageNo }}</div>
              <div class="state-title">{{ item && item.stageName }}</div>
            </div>
          </template>
          <div class="level-title">
            <img
              src="@/assets/images/journey/report_tab_standard@2x.png"
              class="icon-title"
              alt=""
            />
            {{ item.stageEvaluationCriteria }}
          </div>
          <div
            class="level-course"
            v-for="(_item, _key) in item.stageTask"
            :key="_key"
          >
            <div class="title-txt">{{ _item.taskType }}</div>
            <div
              v-for="(item_check, key_check) in _item.journeyStageTasks"
              :key="key_check"
            >
              <div class="txt" v-if="item_check.taskName">
                {{ item_check.taskName }}
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import detailJson from './index.json'

export default {
  name: 'JourneyReport',
  data () {
    return {
      activeNames: [0, 1, 2, 3],
      activeCourse: ['1'],
      detail: detailJson,
    }
  },
  created () {
    this.detail.curJourney = [detailJson.journeys[0]]
    console.log(this.detail)
  },
  methods: {
    handleChangeJounery (item) {
      this.detail.curJourney = [item]
      this.activeNames = [0, 1, 2, 3]
    },
  }
}
</script>
<style lang="less" scoped>
.page-report {
  background-color: #f0f1f6;
  min-height: 100vh;
  .block-flex {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 95px;
    padding-left: 12px;
    padding-top: 16px;
    box-sizing: border-box;
    background: linear-gradient(270deg, #ffb063 0%, #ff5a0b 100%);
    margin-bottom: 23px;
    .flex-nav {
      display: flex;
      align-items: center;
      margin-right: 8px;
      box-sizing: border-box;
      position: relative;
      font-size: 14px;
      &.static1 {
        width: 89px;
        height: 60px;
        padding-left: 15px;
        padding-right: 13px;
      }
      &.static2 {
        width: 91px;
        height: 60px;
        padding-left: 11px;
        padding-right: 2px;
      }
      &.static3 {
        width: 100px;
        height: 60px;
        padding-left: 15px;
        padding-right: 10px;
      }
      &.static4 {
        width: 63px;
        height: 60px;
        padding-left: 12px;
        padding-right: 2px;
        margin-right: 0;
      }
      &.cur {
        .bg-img {
          height: 70px;
        }
        .txt1 {
          color: #000000;
          position: relative;
        }
      }
      .txt1 {
        line-height: 20px;
        font-size: 14px;
        color: #fff;
        position: relative;
      }
      .bg-img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
      }
    }
  }
  .block-info {
    padding: 0 12px;
    box-sizing: border-box;
    .title {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      padding-left: 15px;
      position: relative;
      margin-top: 16px;
      margin-bottom: 15px;
      &::before {
        position: absolute;
        left: 5px;
        width: 4px;
        height: 12px;
        border-radius: 4px;
        background-color: #EB1700;
        top: 50%;
        transform: translateY(-50%);
        content: '';
      }
    }
  }
  .block-level {
    padding: 17px 15px;
    padding-top: 0;
    box-sizing: border-box;
    /deep/.level-item {
      padding: 16px 15px;
      box-sizing: border-box;
      background-color: #fff;
      margin-bottom: 23px;
      border-radius: 8px;
      .van-cell {
        overflow: visible;
      }
      .col-title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #000;
        .report-img {
          position: absolute;
          top: -22px;
          left: 0;
          height: 15px;
          width: auto;
          z-index: 9;
        }
        .state-name {
          font-size: 14px;
          width: 50px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin-right: 10px;
          border-radius: 100px;
          background: linear-gradient(270deg, #ff941c 0%, #EB1700 100%);
          color: #fff;
        }
      }
      .van-collapse-item__wrapper {
        padding-left: 60px;
        box-sizing: border-box;
      }
      &::before {
        position: absolute;
        left: 37px;
        border-left: 1px dashed #979797;
        content: '';
        height: calc(100% - 56px);
        top: 40px;
        transform: inherit;
      }
      .txt {
        font-size: 12px;
        color: #333333;
        line-height: 20px;
        margin-top: 8px;
        padding-left: 8px;
        position: relative;
        &::before {
          position: absolute;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #EB1700;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          content: '';
        }
      }
      &.cur_level {
        .van-collapse-item {
          &::before {
            background: linear-gradient(
              270deg,
              rgba(255, 91, 12, 0) 0%,
              #EB1700 100%
            ) !important;
          }
        }
        &::after {
          position: absolute;
          left: 0;
          border-left: 7px solid #EB1700;
          content: '';
          height: 100%;
          top: 0;
          transform: inherit;
          border-bottom-left-radius: 8px;
          border-top-left-radius: 8px;
        }
      }
      /deep/.van-cell__title {
        font-size: 16px;
        color: #000;
        font-weight: 500;
      }
      .level-title {
        display: flex;
        font-size: 12px;
        color: #333333;
        margin-top: 9px;
        margin-bottom: 15px;
        .level-txt {
          margin-right: 10px;
        }
        .icon-title {
          width: 53px;
          height: 20px;
          margin-right: 3px;
        }
      }
      .tip {
        font-size: 12px;
        color: #EB1700;
        margin-bottom: 4px;
      }
      .level-course {
        border-radius: 2px;
        position: relative;
        margin-bottom: 8px;
        padding: 6px 7px;
        box-sizing: border-box;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
        &::before {
          background: linear-gradient(
            270deg,
            rgba(171, 172, 204, 0.14) 0%,
            #abaccc 100%
          );
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.17;
          z-index: 0;
          content: '';
        }
        .title-txt {
          font-size: 12px;
          color: #333333;
          line-height: 30px;
        }
        .van-cell__title {
          font-size: 12px;
          color: #333333;
        }
        .van-cell {
          background: transparent;
        }
        .van-collapse-item__wrapper {
          padding-left: 0;
        }
        .van-collapse-item {
          margin-bottom: 8px;
          padding: 6px 7px;
          box-sizing: border-box;
          z-index: 9;
          &::before {
            background: linear-gradient(
              270deg,
              rgba(171, 172, 204, 0.14) 0%,
              #abaccc 100%
            );
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.17;
            z-index: -1;
            content: '';
          }
          &::after {
            border: none;
          }
          &:nth-last-child(1) {
            margin-bottom: 0;
          }
          .van-collapse-item__content {
            background: transparent;
          }
        }
      }
    }
  }
}
/deep/.van-cell {
  padding: 0;
}
/deep/.van-collapse-item__content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/growthJourney/growthJourney copy.vue